import React from "react";
import Imgix from "react-imgix";
import cx from "classnames";
import IntOrExtLink from "./IntOrExtLink";
import { endSlash } from "../util/helperFunctions";


const CTABlock = ({ heading, ctas = [], img, altText = "" }) => (
  <div className="cta-block w-100 relative">
    <h2 className="cta-block__heading h-2">{heading}</h2>
    <div className="cta-block__buttons">
      {ctas.map(({ url, text }, ix) => (
        <IntOrExtLink
          key={url}
          className={cx("flex items-center justify-center h-5 ttu w-100", {
            "form__button bg-blue bg-ease-out b--none white mb1 mb0-l mr1-l": !(ix % 2),
            "button--std bg-white hover-bg-stone bg-ease-out ml1-l dark": ix % 2
          })}
          to={endSlash(url)}
        >
          {text}
        </IntOrExtLink>
      ))}
    </div>
    <Imgix
      src={img}
      className="cta-block__image bg-center image-cover mb0 h-100 w-100 bg-grey1"
      imgixParams={{
        "max-w": 2120,
        auto: ["compress"],
        fit: "crop",
        crop: "focalpoint",
        bri: "-10"
      }}
      htmlAttributes={{
        alt: altText
      }}
    />
  </div>
);

export default CTABlock;



// WEBPACK FOOTER //
// ./src/components/CTABlock.js